import { render, staticRenderFns } from "./EditorRow.vue?vue&type=template&id=281e86a7&"
import script from "./EditorRow.vue?vue&type=script&lang=js&"
export * from "./EditorRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports